<template>
  <div id="park-list" class="park-list">
    <div class="search-box">
      <el-form :model="search" ref="search">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="name">
              <el-autocomplete
                prefix-icon="el-icon-search"
                v-model="search.name"
                :fetch-suggestions="querySearch"
                @select="handleSelect"
                style="width: 100%"
                placeholder="请输入主导产业，行政区划，园区（开发区）名称"
                clearable
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-left: 10px">
            <div>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchList"
                >查询
              </el-button>
              <el-button icon="el-icon-refresh-right" @click="refreshList">
                重置刷新
              </el-button>
            </div>
          </el-col>
        </el-row>
        <!--行政区划 class="bottom-line-dashed"-->
        <div class="title-select">
          <el-row>
            <el-col :span="2"><span class="tool-title">行政区划:</span></el-col>
            <el-col :span="21">
              <div
                class="content"
                :class="[isXzqhShrink ? 'shrink' : '']"
                v-for="item in xzqhList"
                :key="item.id"
              >
                <el-input
                  v-model="countyName"
                  @change="changeCounty"
                  @clear="
                    countyList = [];
                    showList = false;
                    xzqh.zs = null;
                    xzqh.qx = null;
                    isXzqhShrink = true;
                  "
                  style="width: 120px"
                  clearable
                ></el-input>
                <span
                  :class="[xzqh.zs ? '' : 'span-active']"
                  @click="
                    (xzqh.zs = null),
                      (xzqh.qx = null),
                      (countyName = ''),
                      (search.county = null)
                  "
                  >全部</span
                >
                <span
                  v-for="(zs, index) in item.children"
                  :key="index"
                  :class="[xzqh.zs == zs ? 'span-active' : '']"
                  @click="
                    (xzqh.zs = xzqh.zs == zs ? null : zs), (xzqh.qx = null)
                  "
                >
                  {{ zs.label }}
                </span>
                <div
                  class="more"
                  v-if="isXzqhShrink"
                  @click="isXzqhShrink = !isXzqhShrink"
                >
                  ...更多
                </div>
                <div
                  class="shrink-btn"
                  v-if="!isXzqhShrink"
                  @click="isXzqhShrink = !isXzqhShrink"
                >
                  收起
                </div>
              </div>
              <div
                :class="['content content2']"
                v-if="xzqh.zs && !isXzqhShrink"
              >
                <span
                  v-for="(qx, qxIndex) in xzqh.zs.children"
                  :key="qxIndex"
                  :class="xzqh.zs && xzqh.qx == qx ? 'span-active' : ''"
                  @click="xzqh.qx = xzqh.qx == qx ? null : qx"
                  >{{ qx.label }}</span
                >
              </div>
            </el-col>
            <el-col :span="2">
              <span class="tool-title">开发区等级:</span>
            </el-col>
            <el-col :span="21">
              <div class="content">
                <span
                  v-for="(item, index) in Parkclass"
                  :key="index"
                  :class="index == ParkclassActivate ? 'span-active' : ''"
                  @click="
                    (search.parkLevel = item.value), (ParkclassActivate = index)
                  "
                >
                  {{ item.name }}
                </span>
              </div>
            </el-col>
            <div class="input-box scrollbar-definition" v-show="showList">
              <div
                v-for="(item, index) in countyList"
                :key="index"
                @click="selectCounty(item)"
              >
                {{ item.name }}
              </div>
              <div
                v-if="showList && !countyList.length"
                @click="showList = false"
              >
                无匹配数据
              </div>
            </div>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="park-list-table-no-top">
      <div class="comparison-switch">
        <!-- <el-switch v-model="isComparison" active-text="对比"></el-switch> -->
      </div>
      <div>
        <span>未找到地块？</span>
        <span class="font-red" @click="releaseNeed">提交需求！</span>
      </div>
    </div>

    <!-- <div id="badge-box" class="badge-box" v-if="isComparison">
      <el-badge
        :value="contrastList.length"
        class="item"
        style="font-size: 1.55rem; cursor: pointer"
      >
        <img
          class="badge-img"
          src="@/assets/images/common/list.png"
          @click="detailedListsShow"
        />
      </el-badge>
    </div> -->
    <div
      class="table-box"
      v-if="tableList.length || loading"
      v-loading="loading"
    >
      <div
        class="card-base"
        v-for="(item, index) in tableList"
        :key="index"
        v-show="tableList.length"
        :style="index + 1 == 5 || index + 1 == 10 ? 'margin-right:0' : ''"
      >
        <div>
          <div class="card-base-box" @click="goDetails(item)">
            <img
              :src="
                item.imgUrl
                  ? item.imgUrl
                  : require('../../assets/images/home/land.png')
              "
              height="162px"
              width="245px"
              alt=""
            />
          </div>
          <div style="padding: 10px 0">
            <span class="card-title">{{ item.name }}</span>
            <div
              :class="
                item.parkLevel == '1'
                  ? 'card-development'
                  : item.parkLevel == '2'
                  ? 'card-development1'
                  : 'card-development2'
              "
            >
              {{ item.parkLevelName }}
            </div>

            <!-- <el-tag
              class="card-info"
              v-if="item.parkLevelName == '国家级开发区'"
              type="danger"
              >{{ item.parkLevelName }}
            </el-tag>
            <el-tag v-else class="card-info">{{
              item.parkLevelName ? item.parkLevelName : "其他"
            }}</el-tag> -->

            <!--            <el-tag class="card-info" type="info">{{ item.parkType }}</el-tag>-->

            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <span v-for="(i, j) in item.labels" :key="j">
                  {{ i.labelName }}
                </span>
              </div>
              <div
                class="park-leadingIndustry"
                v-if="item.labels && item.labels.length"
              >
                <span v-for="(i, j) in item.labels" :key="j">
                  {{ i.labelName }}
                </span>
              </div>
            </el-tooltip>
            <div
              :id="index == 0 ? 'park-list-table-checkbox' : ''"
              class="park-list-table-checkbox"
              @click.stop=""
              v-if="isComparison"
            >
              <el-checkbox
                v-model="item.checked"
                size="medium"
                :true-label="1"
                :false-label="0"
                @change="changeChecked($event, item)"
              ></el-checkbox>
            </div>
            <!--展示浏览量-->
            <el-tooltip placement="right" :open-delay="1000">
              <div slot="content">
                浏览量：{{ item.statistical | filter_statistical }}
              </div>
              <div class="pageView" v-if="!isComparison">
                <browse :statistical="item.statistical"></browse>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="park-list-table-no" v-show="!tableList.length && !loading">
      <div class="park-list-table-no-c">
        <div class="park-list-table-no-c-img">
          <img src="../../assets/images/common/2.png" alt="" />
        </div>
        <div class="park-list-table-no-c-span">
          抱歉，没有找到符合条件的结果，您可以去
        </div>
        <div class="park-list-table-no-c-btn" @click="releaseNeed">
          提交需求
        </div>
      </div>
    </div>
    <div class="page-box" v-if="tableList.length">
      <el-pagination
        :current-page="search.current"
        :page-sizes="[10, 20, 40, 80]"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        layout=" prev, pager, next,total, jumper "
        :total="total"
      ></el-pagination>
    </div>
    <!-- 对比清单 -->
    <div class="contrast-list" v-show="isDetailedList">
      <detailed-list
        :contrast-list="contrastList"
        @callBack="callBack"
      ></detailed-list>
    </div>
    <tools>
      <template v-slot:contrast>
        <div id="badge-box" v-if="isComparison">
          <el-badge
            :value="contrastList.length"
            class="item"
            style="font-size: 1.55rem; cursor: pointer"
          >
            <img
              class="badge-img"
              src="@/assets/images/common/list.png"
              @click="detailedListsShow"
            />
          </el-badge>
        </div>
      </template>
    </tools>
  </div>
</template>
<script>
import { getXzqhList, getXzqhListUpgrade } from "@/api/common";
import {
  getParkPage,
  getAdministrative,
  searchDefault,
} from "@/api/setting/investment";
import card from "./components/card";
import detailedList from "./components/detailedList";
import Driver from "driver.js";
import Browse from "@/components/currency/browse";
import Tools from "@/views/home/components/tools";
export default {
  name: "parkList",
  components: { card, detailedList, Browse, Tools },
  data() {
    return {
      countyName: "",
      xzqh: {
        //行政区划对象
        zs: null, //洲市
        qx: null, //区县
      },
      isXzqhShrink: true, //行政区划是否展开
      showList: false, //搜索行政区划列表是否显示
      countyList: [],
      search: {
        name: "",
        xzqh: [],
        county: "",
        type: "",
        size: 10,
        current: 1,
        approvalStatus: 3,
        parkLevel: null,
      },
      total: 0,
      tableList: [],
      xzqhList: [],
      loading: true,
      contrastList: [],
      isDetailedList: false,
      isComparison: false,
      restaurants: [],
      Parkclass: [
        { name: "全部", value: "" },
        { name: "国家级", value: "1" },
        { name: "省级", value: "2" },
        { name: "其他", value: "3" },
      ],
      ParkclassActivate: 0,
    };
  },
  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  watch: {
    "search.name": function (val) {
      if (val) {
        let list = JSON.parse(sessionStorage.getItem("parkSearchList"))
          ? JSON.parse(sessionStorage.getItem("parkSearchList"))
          : [];
        if (list.length) {
          let index = list.findIndex((item) => item.value == val);
          if (index == -1) {
            list.push({ value: val });
            sessionStorage.setItem("parkSearchList", JSON.stringify(list));
          }
        } else {
          list.push({ value: val });
          sessionStorage.setItem("parkSearchList", JSON.stringify(list));
        }
        this.restaurants = JSON.parse(sessionStorage.getItem("parkSearchList"))
          ? JSON.parse(sessionStorage.getItem("parkSearchList"))
          : [];
      }
    },
    xzqh: {
      deep: true,
      handler(newVal) {
        if (newVal.zs && newVal.qx == null) {
          this.search.county = newVal.zs.value;
        }
        if (newVal.zs && newVal.qx) {
          this.search.county = newVal.qx.value;
        }
        if (newVal.zs == null && newVal.qx == null) {
          this.search.county = null;
        }
        this.searchList();
      },
    },
    //监听行政区划值变化
    countyName: function (val) {
      if (!val) {
        this.xzqh.zs = null;
        this.xzqh.qx = null;
        this.isXzqhShrink = true;
      }
    },
    "search.parkLevel": {
      handler(newVal) {
        this.searchList();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事件
  },
  mounted() {
    this.restaurants = JSON.parse(sessionStorage.getItem("parkSearchList"))
      ? JSON.parse(sessionStorage.getItem("parkSearchList"))
      : [];
    if (!this.restaurants.length) {
      this.getSearchDefault();
    }
    this.getXzqh();
    this.getList();
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
  },
  methods: {
    //搜索默认值
    getSearchDefault() {
      searchDefault({ type: 0 }).then((res) => {
        if (res.data.success) {
          this.restaurants = res.data.data;
        }
      });
    },

    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(item) {},
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    //输入搜索行政区划列表
    changeCounty(val) {
      if (val) {
        this.showList = true;
        getAdministrative({ name: val }).then((res) => {
          if (res.data.success) {
            this.countyList = res.data.data;
          }
        });
      } else {
        this.search.county = "";
        this.searchList();
      }
    },
    //搜索后点击选择行政区划列表
    selectCounty(data) {
      this.search.county = data.code;
      this.countyName = data.name;
      this.showList = false;
      let childrenS = this.xzqhList[0].children;
      if (data.code.length == 4) {
        let index = childrenS.findIndex((item) => data.code == item.value);
        if (index != -1) {
          this.xzqh.zs = childrenS[index];
          this.isXzqhShrink = false;
        }
      }
      if (data.code.length == 6) {
        let str1 = data.code.slice(0, 4);
        let index = childrenS.findIndex((item) => str1 == item.value);
        if (index != -1) {
          this.xzqh.zs = childrenS[index];
          this.isXzqhShrink = false;
          let index1 = childrenS[index].children.findIndex(
            (item) => data.code == item.value
          );
          if (index1 != -1) {
            this.xzqh.qx = childrenS[index].children[index1];
          }
        }
      }
      this.searchList();
    },
    // 加载功能引导
    guide() {
      let driver = new Driver();
      driver.defineSteps([
        {
          element: "#park-list-table-checkbox",
          popover: {
            title: "第一步：勾选园区，勾选两个以上",
            description: "需要勾选两个以上的园区才可以进行对比。",
            position: "left",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
        {
          element: "#badge-box",
          popover: {
            title: "第二步：点击对比",
            description:
              "勾选完园区后，点击这里，会弹出已选择的园区的列表，再点击对比按钮就可以开始对比啦。",
            position: "bottom",
            doneBtnText: "确定",
            closeBtnText: "关闭",
            nextBtnText: "下一步",
            prevBtnText: "上一步",
          },
        },
      ]);
      driver.start();
    },
    callBack() {
      this.isDetailedList = false;
    },

    //获取行政区划
    getXzqh() {
      getXzqhListUpgrade().then((res) => {
        // this.xzqhList=res.data.data
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },

    //添加需求
    releaseNeed() {
      this.$router.push({
        path: "/land/releaseNeed",
      });
    },
    searchList() {
      if (this.search.xzqh.length) {
        this.search.county = this.search.xzqh[this.search.xzqh.length - 1];
      }
      this.search.current = 1;
      this.getList();
    },

    //刷新
    refreshList() {
      this.$refs["search"].resetFields();
      // this.search.xzqh = [];
      this.xzqh = {
        //行政区划对象
        zs: null, //洲市
        qx: null, //区县
      };
      this.search.county = "";
      this.getList();
    },
    //切换页码
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },

    //切换页条数
    handleSizeChange(val) {
      this.search.size = val;
      this.getList();
    },

    getList() {
      this.loading = true;
      getParkPage(this.search).then((res) => {
        if (res.data.success) {
          this.total = res.data.data.total;
          let list = res.data.data.records;
          list.forEach((item) => {
            if (item.pronounceImages) {
              let imgUrl =
                item.pronounceImages.length > 0
                  ? systemConfig.imgServer +
                    systemConfig.imgApi +
                    item.pronounceImages[0].filePath
                  : null;
              this.$set(item, "imgUrl", imgUrl);
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
            if (item.pronounceImages && item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
            this.$set(item, "checked", 0);
            this.contrastList.forEach((cItem) => {
              if (item.id == cItem) {
                item.checked = 1;
              }
            });
          });

          this.tableList = list;
          this.loading = false;
        } else {
          this.$message.error("查询失败");
          this.loading = false;
        }
      });
    },
    changeChecked(e, data) {
      if (e) {
        this.contrastList.push({ id: data.id, name: data.name });
      } else {
        let index = this.contrastList.findIndex((item) => item.id == data.id);
        this.contrastList.splice(index, 1);
      }
    },
    detailedListsShow() {
      if (!this.contrastList.length) {
        this.$message.warning("请选择需要进行对比的园区！");
        // this.$confirm("您选择的园区为空，是否需要功能引导？").then(() => {
        //   this.guide();
        // });
      } else if (this.contrastList.length < 2) {
        this.$message.warning("请选择至少两个园区进行对比！");
      } else {
        this.isDetailedList = true;
      }
    },
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.getList();
      }
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ path: "/parkDetail", query: { id: item.id } });
    },
    progressFormat(p) {
      return "" + p;
    },
  },
  destroyed() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
  // 缓存组件进如时
  activated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "1405px";
  },
  //缓存组件离开时
  deactivated() {
    let bn = document.getElementById("breadcrumb-nav");
    bn.style.width = "";
  },
};
</script>
<style scoped>
.park-list {
  width: calc(245px * 5 + 10px * 11);
  margin: 0 auto;
  background: #fff;
  padding: 10px 35px;
  position: relative;
  /* min-height: calc(100% - 60px); */
  min-height: calc(100% - 346px);
  /* height: auto; */
  display: inline-table;
}

.search-box {
  display: block;
}

/* .search-box {
  height: 46px;
  width: 100%;
} */
.search-btn {
  display: flex;
  justify-content: flex-end;
}

.badge-box {
  position: absolute;
  top: 100px;
  right: -66px;
}

.badge-img {
  width: 60px;
}

.table-box {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

.park-list-table {
  padding: 40px 0;
  border-bottom: 1px solid #c7c3c3;
  display: flex;
}

.park-list-table-checkbox {
  width: 30px;
  position: absolute;
  right: 7px;
  bottom: 18px;
}

::v-deep .el-checkbox__inner {
  width: 23px;
  height: 23px;
  border: 1px solid #626262;
}

.park-list-table-card {
  width: calc(100% - 50px);
}

::v-deep .el-checkbox__inner::after {
  height: 12px;
  width: 6px;
  top: 2px;
  left: 8px;
}

.park-list-table:hover {
  background: #f9f8f8;
}

.park-list-table:active {
  background-color: #00000010;
}

.page-box {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

::v-deep .page-box .el-pager li {
  border: 1px solid #409eff;
}

::v-deep .el-pagination button:disabled {
  color: #fff;
  background: #409eff;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
}

::v-deep .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
}

.font-red {
  color: red;
  cursor: pointer;
  padding-right: 30px;
}

.park-list-table-no {
  margin-top: 10px;
  width: 100%;
}

.park-list-table-no-top {
  /* text-align: right; */
  /* border-bottom: 1px solid #c7c3c3;
  font-size: 0.8rem;
  font-weight: 600;
  height: 33px;
  line-height: 33px;
  position: relative; */
  border-bottom: 1px solid #c7c3c3;
  font-size: 0.8rem;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
}

.comparison-switch {
  /* display: inline-block;
  position: absolute;
  left: 20px; */
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.park-list-table-no-c {
  width: 400px;
  margin: 63px auto 50px;
}

.park-list-table-no-c-img {
  width: 100%;
}

.park-list-table-no-c-img > img {
  width: 100%;
}

.park-list-table-no-c-span {
  margin: 0 auto;
  width: 50%;
  text-align: center;
  font-size: 0.75rem;
  color: #c7c3c3;
}

.park-list-table-no-c-btn {
  font-size: 0.85rem;
  width: 120px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 20px auto;
  background: #1a6ec2;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.contrast-list {
  position: fixed;
  top: 315px;
  right: 30px;
}

>>> .table-box .el-card {
  width: 245px;
  display: inline-block;
  margin: 10px 10px;
  border-radius: 10px;
  border-top-left-radius: 15px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.card-info {
  margin: 2px 10px;
  font-size: 0.95rem;
}

.card-base {
  display: inline-block;
  position: relative;
  width: calc((100% - 60px) / 5);
  box-shadow: 0 0 4px #c7c3c3;
  margin-top: 15px;
  border-radius: 4px;
  margin-right: 15px;
  overflow: hidden;
}

.card-base-box {
  cursor: pointer;
  width: 100%;
}

.card-base-box > img {
  width: 100%;
}

.card-title {
  margin: 7px 10px;
  font-size: 1.05rem;
  font-weight: bold;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: calc(100% - 20px);
}

/* .pageView {
  width: 100px;
  position: absolute;
  right: -30px;
  bottom: 25px;
} */
.pageView {
  width: 85px;
  position: absolute;
  right: 16px;
  bottom: 15px;
  text-align: right;
}

.color-4 {
  color: red;
}

.color-1 {
  color: #f4420a;
}

.color-2 {
  color: #ff6941;
}

.color-3 {
  color: #ff9001;
}

>>> .pageView .el-progress__text {
  color: #bfbfbf;
  margin: -13px 8px 8px -15px;
}

.title-select {
  border: 1px solid #bfbfbf;
  padding: 20px 10px;
}

.tool-title {
  color: #979797;
  margin-top: 10px;
  display: inline-block;
}

.bottom-line-dashed {
  border-bottom: 1px dashed #b5b5b5;
}

.input-box {
  position: absolute;
  top: 43px;
  left: 105px;
  background: #fff;
  /* border: 1px solid #e4e7ed; */
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 99999;
}

.input-box > div {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 0.8rem;
  cursor: pointer;
}

.content {
  /*position: relative;*/
}

.content span {
  color: #7c7c7c;
  display: inline-block;
  margin: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.95rem;
}

.content span:hover {
  color: #58aec3 !important;
}

.content .span-active {
  color: #1bbafd;
}

.content2 {
  margin-top: 10px;
}

.content2 span {
  font-weight: unset;
}

.bottom-line-dashed {
  border-bottom: 1px dashed #b5b5b5;
  position: relative;
}

.shrink {
  overflow: hidden;
  height: 44px;
}

.shrink-child {
  height: 0;
}

.more {
  position: absolute;
  right: 0px;
  top: 10px;
  font-size: 0.95rem;
  color: #00d2fd;
  cursor: pointer;
}

.shrink-btn {
  position: absolute;
  right: 0px;
  bottom: 10px;
  font-size: 0.95rem;
  color: #00d2fd;
  cursor: pointer;
}

.card-info-tag {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-development {
  width: 120px;
  text-align: center;
  border-radius: 4px;
  margin-left: 10px;
  height: 24px;
  min-height: 24px;
  color: #fff;
  margin-bottom: 10px;
  background: rgb(166, 50, 255);
}

.card-development1 {
  width: 120px;
  text-align: center;
  border-radius: 4px;
  margin-left: 10px;
  height: 24px;
  min-height: 24px;
  color: #fff;
  margin-bottom: 10px;
  background: rgb(246, 99, 0);
}

.card-development2 {
  width: 120px;
  text-align: center;
  border-radius: 4px;
  margin-left: 10px;
  height: 24px;
  min-height: 24px;
  color: #fff;
  margin-bottom: 10px;
  background: #03b9cd;
}
.park-leadingIndustry {
  /* min-width: 70px; */
  max-width: 140px;
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
  background: #ecf5ff;
  border-radius: 4px;
  text-align: center;
  padding: 0 5px;
  width: max-content;
}
</style>

